export default () => ({
  isNuxtReady: false,
  isNavBarOffer: false,
  env: {
    APP_URL: process.env.APP_URL,
    APP_ENV: process.env.APP_ENV,
  },
});
